<template>
  <div>
    <div class="head-top">
      <div class="info-message">
        <div class="info-up">
          <div class="info-up-left">
            <img crossorigin="anonymous" :src="titleInfo?.userImg" alt="" />
            <h2>{{ titleInfo?.userName }}</h2>
          </div>
          <div class="info-up-right" v-if="!duoyushow" @click="goHistory">
            <div v-if="isShowFont">历史周报<van-icon name="arrow" /></div>
          </div>
        </div>
        <div class="info_down">
          <div class="info_down_item">
            <p>{{ titleInfo?.questionCount }}<span>道</span></p>
            <em>答题量</em>
          </div>
          <div class="info_down_item">
            <p>{{ titleInfo?.correctRatio }}<span>%</span></p>
            <em>正确率</em>
          </div>
          <div class="info_down_item">
            <p>{{ titleInfo?.questionCount > 10 ? titleInfo?.rank : '--' }}<span>名</span></p>
            <em>本周排名</em>
            <van-icon v-if="!duoyushow" name="info-o" @click="instrucTionsOpen" />
          </div>
        </div>
      </div>
    </div>

    <InstructionsPop
      v-if="popShow"
      :contentInstructions="contentInstructions"
      :personalSource="true"
      @popClose="popClose"
    />
  </div>
</template>
<script>
import InstructionsPop from './instructionsPop.vue';

export default {
  props: {
    isShowFont: {
      type: String,
      default: "",
    },
    duoyushow: {
      type: Boolean,
      default: false,
    },
    titleInfo: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    InstructionsPop,
  },
  data() {
    return {
      popShow: false,
      // 学习进度说明弹窗
      contentInstructions: [
        '本周排名是按照本周正确率在全站统一排名。',
        '若作答题量小于10道题，不参与排名',
      ],
    };
  },
  mounted() {},
  methods: {
    goHistory() {
      this.$router.push('/weekReport');
    },
    instrucTionsOpen() {
      this.popShow = true;
    },
    popClose() {
      this.popShow = false;
    },
  },
};
</script>

<style scoped lang="scss">
.info-message {
  position: relative;
  width: 678px;
  // height: 290px;
  background: #ffffff;
  border-radius: 14px;
  margin: 0 auto 20px;
  padding: 40px 30px;
  .info-up {
    display: flex;
    justify-content: space-between;
    margin-bottom: 40px;
    .info-up-left {
      display: flex;
      align-items: center;
      margin-top: -60px;
      img {
        display: block;
        width: 145px;
        height: 145px;
        border: 4px solid #ffffff;
        border-radius: 50%;
      }
      h2 {
        width: 240px;
        // background-color: #3333333b;
        font-size: 30px;
        font-weight: 400;
        color: #333333;
        margin-left: 20px;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
        white-space: nowrap;
      }
    }
    .info-up-right {
      font-size: 25px;
      font-weight: 400;
      color: #333333;
    }
  }
  .info_down {
    display: flex;
    justify-content: space-between;
    padding: 0 30px;
    .info_down_item {
      position: relative;
      p {
        font-size: 36px;
        font-weight: normal;
        color: #333333;
        text-align: center;
        margin-bottom: 10px;
        span {
          font-size: 22px;
          font-weight: 400;
          color: #333333;
        }
      }
      em {
        display: block;
        font-style: normal;
        font-size: 25px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #999999;
        text-align: center;
      }
      ::v-deep .van-icon {
        position: absolute;
        right: -10px;
        top: -6px;
        color: #a5a5a5;
        font-size: 16px;
      }
    }
  }
}
</style>
